<template>
    <div>
        <!-- 详情对话框 -->
        <el-dialog :title="templateTypeText" :visible.sync="editVisible" width="90%" customClass="dialogWidth-1000" @close="closeDialog"
                   :close-on-click-modal="false" :before-close="saveAlert" :close-on-press-escape="false">
            <!-- TODO: 暂时先从AoPE代码里拷过来，后面抽成组件复用 -->
            <el-form v-loading="isDialogLoading">
                <el-card class="mb-20" v-for="(questionGroup, index) in questions" :key="index">
                    <template v-for="question in questionGroup">
                        <el-row>
                            <el-col>
                                <el-tooltip class="mb-2 mt-5" effect="dark" placement="bottom" :disabled="question.guidance == ''">
                                    <div style="max-width: 1000px;" slot="content" v-html="question.guidance"></div>
                                    <h4 class="question-title" :style="question.highlighted? 'background:yellow;':''" :id="'question'+ question.id">
                                        {{question.title}}</h4>
                                </el-tooltip>
                            </el-col>
                        </el-row>
                        <template v-if="question == 'table'">
                            <el-row>
                                <el-col>
                                    <el-table :data="question.config.list">
                                        <el-table-column v-for="(cell, index) in question.config.title" v-bind:label="cell.key" :key="index">
                                            <template slot-scope="scope">
                                                <el-input type="textarea" :maxlength="maxLength" v-model="scope.row[cell.value]" @change="checkQuestionInput">
                                                </el-input>
                                            </template>
                                        </el-table-column>
                                    </el-table>
                                </el-col>
                            </el-row>
                        </template>
                        <template v-for="row in question.config.list">
                            <el-row :gutter="20">
                                <template v-for="(col,index) in row">
                                    <el-col :span="Math.floor(col.spans*24)" v-if="col.type == 'input' || col.type == 'link'">
                                        <p class="gary mb-5">{{col.description}}</p>
                                        <el-form-item class="mb-none" prop="answer" ref="col">
                                            <el-input :maxlength="maxLength" type="textarea" v-bind:rows="col.rows" v-model="col.answer"
                                                      v-bind:placeholder="question.config.forTeacher?'To be edited by teacher':''"
                                                      :disabled="question.config.forTeacher" @change="checkQuestionInput"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="Math.floor(col.spans*24)" v-if="col.type == 'text'" :disabled="true">
                                        <p class="gary mb-5">{{col.description}}</p>
                                        <el-form-item class="mb-none" prop="answer">
                                            <el-input :maxlength="maxLength" type="text" v-bind:rows="col.rows" v-model="col.answer"
                                                      v-bind:placeholder="question.config.forTeacher?'To be edited by teacher':''"
                                                      :disabled="question.config.forTeacher" @change="checkQuestionInput"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="Math.floor(col.spans*24)" v-if="col.type=='datetime'">
                                        <p class="gary  mt-5">{{col.dateDescription}}</p>
                                        <el-date-picker
                                                :picker-options="datePickerOptions.option1"
                                                type="date" class="mt-5"
                                                v-model="col.date"
                                                v-bind:placeholder="question.config.forTeacher?'To be edited by teacher':'Select date'"
                                                :disabled="question.config.forTeacher"
                                                @change="isDirty=true;"
                                                style="width: 100%">
                                        </el-date-picker>
                                        <p class="gary mt-5">{{col.timeDescription}}</p>
                                        <el-time-picker
                                                v-model="col.time" class="mt-5"
                                                v-bind:placeholder="question.config.forTeacher?'To be edited by teacher':'Select time'"
                                                :disabled="question.config.forTeacher"
                                                @change="isDirty=true;"
                                                style="width: 100%">
                                        </el-time-picker>
                                    </el-col>
                                    <el-col :span="Math.floor(col.spans*24)" v-if="col.type=='date'" @change="isDirty=true;">
                                        <p class="gary ">{{col.dateDescription}}</p>
                                        <el-date-picker
                                                v-model="col.answer"
                                                :picker-options="datePickerOptions.option1"
                                                type="date" class="mt-5"
                                                v-bind:placeholder="question.config.forTeacher?'To be edited by teacher':'Select date'"
                                                :disabled="question.config.forTeacher"
                                                @change="isDirty=true;"
                                                style="width: 100%">
                                        </el-date-picker>
                                    </el-col>
                                    <el-col :span="Math.floor(col.spans*24)" v-if="col.type=='checkbox'">
                                  <span>
                                      <p class="gary ">{{col.dateDescription}}</p>
                                      <el-checkbox-group v-model="col.answer" @change="isDirty=true;">
                                            <template v-if="col.vertical">
                                                <p v-for="(cb, index) in col.list" :key="index">
                                                    <el-checkbox v-bind:label="cb"></el-checkbox>
                                                </p>
                                            </template>
                                            <template v-else>
                                                <el-checkbox v-for="(cb, index) in col.list" :key="index" v-bind:label="cb"
                                                             :disabled="question.config.forTeacher"></el-checkbox>
                                            </template>

                                       </el-checkbox-group>
                                  </span>
                                    </el-col>

                                    <!-- 新增 -->

                                    <el-col :span="Math.floor(col.spans*24)" v-if="col.type=='radio'">
                                        <template v-if="col.vertical">
                                            <p v-for="(lb, index) in col.list" :key="index">
                                                <el-radio class="radio mb-5" v-model="col.answer" :label="lb" @change="isDirty=true;"></el-radio>
                                            </p>
                                        </template>
                                        <template v-else>
                                            <el-radio class="radio mb-5 mt-5" v-for="(lb, index) in col.list" :key="index" v-model="col.answer" :label="lb"
                                                      @change="isDirty=true;"></el-radio>
                                        </template>
                                    </el-col>

                                    <el-col :span="Math.floor(col.spans*24)" v-if="col.type=='image'" class="mt-5">
                                        <el-upload
                                                :action="uploadUrl"
                                                :data="uploadFormData"
                                                :file-list="clonedImageList"
                                                list-type="picture"
                                                accept="image/jpeg, image/png"
                                                :beforeUpload="handleBeforeImageUpload"
                                                :on-success="function a(response, file, fileList) {handleUploadImageSuccess(response, file, fileList, col.answer)}"
                                                :on-change="handleFileChanged"
                                                :on-preview="handlePictureCardPreview"
                                                :on-error="handleUploadError"
                                                :on-remove="function b(file, fileList) {handleImageRemove(file, fileList, col.answer)}"
                                                :disabled="imageCount >= 5 || isAuthorizing">
                                            <el-button size="small" type="primary" icon="el-icon-upload" :disabled="imageCount >= 5 || isAuthorizing"
                                                       :loading="isAuthorizing">Upload
                                            </el-button>
                                            <div slot="tip" class="el-upload__tip">
                                                {{imageCount >= 5 ? 'You can only upload up to 5 images, please choose the best fit ones.' : '1 to 5 images, only jpg/png allowed, less than 4MB'}}
                                            </div>
                                        </el-upload>
                                    </el-col>

                                    <el-col :span="Math.floor(col.spans*24)" v-if="col.type=='pdf'" class="mt-5">
                                        <el-upload
                                                :action="uploadUrl"
                                                :data="uploadFormData"
                                                :file-list="clonedPDFList"
                                                accept="application/pdf"
                                                :beforeUpload="handleBeforePDFUpload"
                                                :on-success="function a(response, file, fileList) {handleUploadPDFSuccess(response, file, fileList, col.answer)}"
                                                :on-change="handleFileChanged"
                                                :on-preview="handlePDFPreview"
                                                :on-error="handleUploadError"
                                                :on-remove="function b(file, fileList) {handlePDFRemove(file, fileList, col.answer)}"
                                                :disabled="isUploading">
                                            <el-button size="small" type="primary" icon="el-icon-upload" :disabled="isUploading">Upload</el-button>
                                            <div slot="tip" class="el-upload__tip">only pdf allowed, less than 10MB</div>
                                        </el-upload>
                                    </el-col>
                                    <!-- 新增 -->

                                </template>
                            </el-row>
                        </template>
                        <el-row>
                            <el-col class="mt-5" v-if="question.config.more" :span=5>
                                <el-button-group>
                                    <el-button class="p-5" type="danger" v-on:click="more(question.config.list)" size="mini" icon="el-icon-plus"></el-button>
                                    <el-button class="p-5" type="success" v-on:click="less(question.config.list)" size="mini" icon="el-icon-minus"></el-button>
                                </el-button-group>
                            </el-col>
                        </el-row>
                        <el-row v-if="role == 'student' || role == 'ta'">
                            <el-col :span="24" class="p-10 bg-lightgarg mt-5" v-if="question.commentList && question.commentList.length != 0">
                                <el-button v-if="question.showCommentCount ==3 && question.commentList.length > 3"
                                           v-on:click="question.showCommentCount = question.commentList.length" type="text">
                                    View {{question.commentList.length - showCommentCount}} more comments
                                </el-button>
                                <el-button v-if="question.showCommentCount !=3 && question.commentList.length > 3" v-on:click="question.showCommentCount = 3"
                                           type="text">Hide more
                                </el-button>
                                <div>
                                    <div v-for="(comment,commentIndex) in question.commentList" :key="commentIndex"
                                         v-show="commentIndex > question.commentList.length-question.showCommentCount-1">
                                        <div :style="comment.highlighted?'background:yellow;':''" class="commentContent dark mt-5 pb-0"
                                             :id="'comment'+comment.id">
                                            <span class="success"><b>{{comment.fromName}}</b></span><span> : {{comment.content}}</span>
                                        </div>
                                        <div class="gary mb-2">{{comment.time}}
                                            <el-button type="text" class="ml-5" size="mini" @click="cancelComment(comment, question.commentList)"
                                                       v-if="comment.userId == currentCommentatorId">
                                                remove
                                            </el-button>
                                        </div>
                                    </div>
                                </div>
                            </el-col>
                        </el-row>
                        <el-row class="mb-10 mt-5" v-if="role == 'student' || role == 'ta'">
                            <el-col :span="1">
                                <el-button type="success" v-if="!question.config.forTeacher" size="mini" v-on:click="question.show = !question.show">
                                    {{question.show ? '&nbsp;&nbsp;&nbsp;&nbsp;Hide&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' : 'Comment'}}
                                </el-button>
                            </el-col>
                        </el-row>
                        <el-row class="mb-10" v-show="question.show" v-loading="question.isSavingComment">
                            <el-col :span="20">
                                <el-input class="post-textarea" type="textarea" autofocus :rows="3" resize="none"
                                          @keyup.native="pressAction(question,question.commentList,$event)"
                                          placeholder="Press Ctrl + Enter to post"
                                          v-model="question.content" @change="checkEmoji"></el-input>
                            </el-col>
                            <el-col :span="3">
                                <el-button type="success" v-on:click="saveComment(question,question.commentList)" size="small" :disabled="!question.content"
                                           class="comment-submit p-30">Post
                                </el-button>
                            </el-col>
                        </el-row>
                    </template>
                </el-card>
            </el-form>

            <div slot="footer" class="dialog-footer">
                <el-button @click="saveAlert(function() {editVisible = false})">Cancel</el-button>
                <el-button type="primary" :loading="saving" :disabled="isUploading || isDialogLoading" @click="saveAnswer">OK</el-button>
            </div>
        </el-dialog>

        <!-- 图片预览对话框 -->
        <el-dialog :visible.sync="picReview" width="90%" customClass="dialogWidth-1000" title="Preview" :modal="true">
            <img width="100%" :src="dialogImageUrl" alt="">
        </el-dialog>
        <!-- pdf预览 -->
        <a ref="pdfPreview" target="_blank"></a>
    </div>
</template>

<script>
  import util from '../../component/util.js'
  import Cookies from 'js-cookie'
  const templateTypeDefinition = [
//    'Witness testimony', //0
//    'Peer/Witness statement', //1
//    'Team action plan', //2
//    'Personal action plan', //3
//    'Action plan', //4
//    'PDF', //5
//    'Image', //6
//    'Video link', //7
//    'Observation checklist', //8 COPE-D
//    'Observation checklist'] //9 COPE-OP
      'PDF', //0
      'Image', //1
      'Video link', //2
      'Peer/Witness statement', //3
      'Observation checklist', //4 COPE-D
      'Observation checklist', //5 COPE-OP
      'Observation checklist', //6 AOPE-ISP
  ]
  export default {
    props: [
      // userId表示当前EvidenceDialog所有者的id，通常是表示Student UserId
      'userId',
      'isLineRead',
      'notificationId',

      'studentId'
    ],

    data() {
      return {
        // 固定的
        showCommentCount: 3,
        maxLength: 4000,
        datePickerOptions: {
          option1: {}
        },

        // 有状态的
        evidenceId: 0,
        currentCommentatorId: 0,
        templateTypeText: '',
        questions: [],
        oldQuestions: [],
        comments: [],
        hasOldQuestions: false,
        editVisible: false,
        saving: false,
        isDialogLoading: false,
        isDirty: false,

        // 上传相关
        expire: 0,
        uploadUrl: '/api/pageEvidence/upload',
        uploadFormData: {},
        dialogImageUrl: '',
        picReview: false,
        pdfPreviewUrl: '',
        imageCount: 0, // 已上传的图片数量
        clonedImageList: [],
        clonedPDFList: [],
        isUploading: false,
        isAuthorizing: false,// 是否正在获取授权中，授权过程中不允许再次点击上传

        // 仅用于教师端confirm时，会在showEvidenceDialog中传来
        confirmed: false,
        role: '',
        isAdd: false
      }
    },
    methods: {
      init() {
        // 将当前userId获取下来，作为当前评论者的id，用于评论部分remove按钮的渲染，满足自己只能删自己评论的情况。
        this.currentCommentatorId = Cookies.get('userid');

        this.role = Cookies.get('role');
      },

      //POST键盘事件
      pressAction: function (question, commentList, ev) {
        if (13 == ev.keyCode && ev.ctrlKey) { //ctrl + enter
          if (question.content && !question.isSavingComment) { // 有输入值且没有正在保存。因为是代码触发，所以必须加上这个判断
            this.saveComment(question, commentList)
          }
        }
      },

      setHighlight(list, id, successFn) {
        (list || []).forEach(items => {
          items.forEach(item => {
            if (item.id === id) {
              successFn && successFn(item);
            }
          })
        })
      },

      handleConfirmEvidence() {
        this.isDialogLoading = true
        this.$http.patch(`pageEvidence/confirm/${this.evidenceId}`).then(res => {
          this.isDialogLoading = false
          this.$emit('confirmed')
          this.confirmed = true
          this.$message.success('confirm success')
        }).catch(err => {
          this.isDialogLoading = false
          this.$message.error(err.message)
        })
      },

      handleDisapproveEvidence() {
        this.isDialogLoading = true
        this.$http.patch(`pageEvidence/disapprove/${this.evidenceId}`).then(res => {
          this.isDialogLoading = false
          this.$emit('disapproved')
          this.confirmed = false
          this.$message.success('disapprove success')
        }).catch(err => {
          this.isDialogLoading = false
          this.$message.error(err.message)
        })
      },

        /*------------------- Copy自AoPE.vue -------------------*/

      //将数据渲染到模态框中
      handleQuestionList: function (list, params) {
        //清空this.questions
        this.questions.splice(0, this.questions.length)

        var count = 0;
        for (var i = 0; i < list.length; i++) {
          var group = [];
          for (var j = 0; j < list[i].length; j++) {
            list[i][j].show = false;
            //绑定comment
            list[i][j].content = '';
            list[i][j].isSavingComment = false;
            // list[i][j].showCommentCount = this.showCommentCount;
            list[i][j].commentList = this.comments[count];
            list[i][j].showCommentCount = 3;

            let config = JSON.parse(list[i][j].config)

            // 解析config（question或answer）逻辑
            if (config != '') {
              for (let j = 0; j < config.list.length; j++) {

                for (let k = 0; k < config.list[j].length; k++) {
                  if (config.list[j][k] != undefined) {
                    if (config.list[j][k].type === 'image') {
                      if (config.list[j][k].answer != undefined) {
                        // 从没保存过时，初始化为空数组
                        if (config.list[j][k].answer === '') {
                          config.list[j][k].answer = []
                        }

                        // Note: 这段逻辑理论上有问题，如果有多个上传组件时就是错的了
                        // 深拷贝col.answer，用于upLoad组件 file-list的数据源
                        this.clonedImageList = this.deepClone(config.list[j][k].answer)
                        // 得到当前已经上传的文件数量
                        this.imageCount = config.list[j][k].answer.length
                        // 克隆后的数组里url加上缩略图后缀
                        // this.clonedImageList.forEach(file => file.url = util.resizeOSSImage.switchResizeToThumbnail(file.url))
                      }
                    } else if (config.list[j][k].type === 'pdf') {
                      if (config.list[j][k].answer === '') {
                        config.list[j][k].answer = []
                      }
                      // Note: 这段逻辑理论上有问题，如果有多个上传组件时就是错的了
                      // 深拷贝col.answer，用于upLoad组件 file-list的数据源
                      this.clonedPDFList = this.deepClone(config.list[j][k].answer)
                    }
                  }
                }
              }
            }

            list[i][j].config = config
            group.push(list[i][j]);
            count++;
          }
          this.questions.push(group);

        }

        this.refreshOldQuestions();

        if (params !== undefined && params !== null) {
          if (params.type === 'evidence') {
            let questionId = params.questionId;
            this.setHighlight(this.questions, questionId, item => {
              item.highlighted = true;
            })
          }

          if (params.type === 'comment') {
            let commentId = params.commentId;
            this.setHighlight(this.comments, commentId, item => {
              item.highlighted = true;
            })

            // 遍历questions，判断当前评论所在位置，如果所在位置小于评论长度-3，表明当前评论被hide，需要将其展开，否则不做处理
            // forEach() => 数组源生方法，用于遍历数组项
            this.questions.forEach(qs => {
              // qs => question部分
              qs.forEach(q => {
                // q => 每一个question
                q.commentList.forEach((c, i) => {
                  // c => 每一个question的comment
                  if (c.id === commentId && i < q.commentList.length - 3) {
                    q.showCommentCount = q.commentList.length;
                  }
                })
              })
            })
          }
        }

        // 走到这一步所有详情对话框需要的数据都已经加载完了
        this.isDialogLoading = false
        window.onbeforeunload = function () {
          return "你的表单有些修改尚未保存，是否确定要离开?\nSome changes aren\'t saved. Are you sure leaving the page?";
        }

        window.onunload = function () {
          return "你的表单有些修改尚未保存，是否确定要离开?\nSome changes aren\'t saved. Are you sure leaving the page?";
        }

        //因为element在给date组件赋值的之后已经触发了其change时间，进而isdirty被置为true，因此，此段代码让页面在加载完成数据之后将其置为false
        setTimeout(() => {
          this.isDirty = false;
          // 跳转到指定元素前
          if (params) {
            if (params.type === 'comment') {
              let commentDom = document.getElementById('comment' + params.commentId);
              commentDom && commentDom.scrollIntoView();
            } else if (params.type === 'evidence') {
              let evidenceDom = document.getElementById('question' + params.questionId);
              evidenceDom && evidenceDom.scrollIntoView();
            }
          }
        }, 0);
      },

      clone: function (myObj) {
        if (typeof(myObj) != 'object') return myObj;
        if (myObj == null) return myObj;
        var myNewObj = new Object();
        for (var i in myObj)
          myNewObj[i] = this.clone(myObj[i]);
        return myNewObj;
      },

      checkQuestionInput: function (value) {
        this.isDirty = true;
        this.checkEmoji(value);
      },

      checkEmoji: function (value) {
        let regStr = /[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF][\u200D|\uFE0F]|[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF]|[0-9|*|#]\uFE0F\u20E3|[0-9|#]\u20E3|[\u203C-\u3299]\uFE0F\u200D|[\u203C-\u3299]\uFE0F|[\u2122-\u2B55]|\u303D|[\A9|\AE]\u3030|\uA9|\uAE|\u3030/ig;
        if (regStr.test(value)) this.$message.warning('Emoji is not supported, please remove it from your answer or comment.');
      },

      refreshOldQuestions: function () {
        if (this.hasOldQuestions) {
          this.oldQuestions = []
          this.questions.forEach(group => {
            let oldGroup = [];
            group.forEach(question => {
              let list = [];
              for (let i = 0; i < question.config.list.length; i++) {
                if (question.config.list[i] instanceof Array) {
                  let temp = [];
                  for (let j = 0; j < question.config.list[i].length; j++) {

                    //此处将对象序列化后在反序列化的目的是深拷贝对象，没有使用methods中的clone方法是因为
                    //element日期控件中的值发生变化时，如果使用clone方法复制对象会造成日期控件的值变成一个空的object
                    temp.push(JSON.parse(JSON.stringify(question.config.list[i][j])));
                  }
                  list.push(temp);
                } else {
                  list.push(JSON.parse(JSON.stringify(question.config.list[i])))
                }

              }
              let oldQuestion = {config: {list: list}}
              oldGroup.push(oldQuestion);
            });
            this.oldQuestions.push(oldGroup)
          })
        }
      },

      //获取指定evidence的问题，当前evidence没有answer时请求加载
      getQuestion: function (templateType, params) {
        this.$http.get('question/pageEvidence/' + templateType).then(response => {
          this.hasOldQuestions = false;
          this.handleQuestionList(response, params);
        }).catch(error => {
          this.$message.error(error);
        });
      },

      //请求当前evidence答案
      getAnswer: function (evidenceId, templateType, params) {
        this.$http.get('pageEvidence/answer/' + evidenceId).then(response => {
          //存在则显示，不存在则请求question
          if (response.length == 0) {
            this.getQuestion(templateType, params);
          } else {
            this.hasOldQuestions = true;
            this.handleQuestionList(response, params);
          }
        }).catch(error => {
          this.$message.error(error);
        });
      },

      //通过此函数获得请求并显示dialog所需的所有数据
      getDialogAll: function (evidenceId, templateType, params) {
        //请求当前page评论
        this.$http.get('comment/pageEvidence/' + evidenceId).then(response => {
          this.comments = response;
          this.getAnswer(evidenceId, templateType, params)
        }).catch(error => {
          this.$message.error(error);
        });
      },

      isQuestionDirty: function (question, groupIndex, questionIndex) {
        if (!this.hasOldQuestions) {
          for (let i = 0; i < question.config.list.length; i++) {
            let row = question.config.list[i];
            for (let index in row) {
              let col = row[index];
              let type = col.type;
              if (type === 'input' || type === 'tableInput' || type === 'text' || type === 'radio' ||
                type === 'date' || type === 'tableDate' || type === 'link') {
                if (question.initialEmpty === undefined || question.initialEmpty) question.initialEmpty = col.answer === '';
              }

              if (type === 'datetime') {
                if (question.initialEmpty === undefined || question.initialEmpty) question.initialEmpty = col.date === '' && col.time === '';
              }

              if (type === 'checkbox' || type === 'pdf' || type === 'image') {
                if (question.initialEmpty === undefined || question.initialEmpty) question.initialEmpty = col.answer === '' || col.answer.length === 0;
              }
            }
          }
          return true;
        }
        question.initialEmpty = false;
        let oldQuestion = this.oldQuestions[groupIndex][questionIndex];
        if (oldQuestion.config.list.length !== question.config.list.length) return true;
        for (let i = 0; i < question.config.list.length; i++) {
          let row = question.config.list[i];
          let oldRow = oldQuestion.config.list[i];
          for (let index in row) {
            let oldCol = oldRow[index];
            let col = row[index];
            let type = col.type;
            if (type === 'input' || type === 'tableInput' || type === 'text' || type === 'radio' || type === 'link') {
              if (col.answer !== oldCol.answer) return true;
            }

            if (type === 'date' || type === 'tableDate') {
              let oldDate = oldCol.answer === '' ? '' : Date.parse(new Date(oldCol.answer));
              let date = col.answer === '' ? '' : Date.parse(new Date(col.answer));
              if (oldDate !== date) return true;
            }

            if (type === 'datetime') {
              let oldDate = oldCol.date === '' ? '' : Date.parse(new Date(oldCol.date));
              let date = col.date === '' ? '' : Date.parse(new Date(col.date));
              let oldTime = oldCol.time === '' ? '' : Date.parse(new Date(oldCol.time));
              let time = col.time === '' ? '' : Date.parse(new Date(oldCol.time));
              if (date !== oldDate || time !== oldTime) {
                return true;
              }
            }

            if (type === 'pdf' || type === 'image') {
              let count = 0;
              let answerBoxes = [];
              for (let boxIndex in oldCol.answer) {
                answerBoxes.push(oldCol.answer[boxIndex]);
                count++;
              }
              if (col.answer.length !== count) return true;
              for (let x = col.answer.length - 1; x >= 0; x--) {
                // 还需要判断图片前后url是否一致，防止一增一减图片或pdf时，无法保存
                if (col.answer[x].uid !== answerBoxes[x].uid || col.answer[x].url !== answerBoxes[x].url) return true;
              }
            }

            if (type === 'checkbox') {
              let count = 0;
              let answerBoxes = [];
              for (let boxIndex in oldCol.answer) {
                answerBoxes.push(oldCol.answer[boxIndex]);
                count++;
              }
              if (col.answer.length !== count) return true;
              for (let x = 0; x < col.answer.length; x++) {
                if (col.answer[x] !== answerBoxes[x]) return true;
              }
            }
          }
        }
        return false;
      },

      closeDialog: function () {
        this.isDirty = false;
        window.onbeforeunload = null;
        window.onunload = null;
        if (!this.isLineRead) {
          this.$emit('close', {id: this.notificationId})
        }
      },

      //处理显示当前templateType的所有逻辑
      showEvidenceDialog: function (type, evidenceId, params, confirmed, isAdd) {
        if (type == undefined) return;
        this.evidenceId = evidenceId;
        this.confirmed = confirmed // 教师端会传此参数
        this.isAdd = isAdd
        this.reset()
        this.isDialogLoading = true
        this.editVisible = true
        this.templateTypeText = templateTypeDefinition[type]
        this.getDialogAll(evidenceId, type, params);
      },
      reset(){
        this.questions = []
        this.oldQuestions = []
        this.saving = false
        this.hasOldQuestions = false
        this.isDirty = false
        // 上传相关
        this.expire = 0
        // this.uploadUrl = ''
        this.uploadFormData = {}
        this.dialogImageUrl = ''
        this.picReview = false
        this.pdfPreviewUrl = ''
        this.clonedImageList = []
        this.clonedPDFList = []
        this.imageCount = 0
        this.isAuthorizing = false
        this.isUploading = false
      },

      saveAnswer: function () {
        if (!this.isDirty) {
          this.$message({
            type: 'warning',
            message: 'Evidence hasn\'t been edited'
          });
          this.saving = false;
          return;
        }
        var postQuestionList = [];
        this.saving = true;
        this.questions.forEach((group, groupIndex) => {
          group.forEach((question, questionIndex) => {
            console.log('saving: ', question, questionIndex)
            if (this.isQuestionDirty(question, groupIndex, questionIndex)) {
              var answer = {
                id: question.answerId,
                evidenceId: this.evidenceId,
                evidenceQuestionId: question.id,
                answer: JSON.stringify(question.config),
                initialEmpty: question.initialEmpty
              }
              postQuestionList.push(answer);
            }
          });
        });

        if (postQuestionList.length === 0) {
          this.saving = false;
          this.$message.warning('Portfolio hasn\'t been edited, nothing saved.');
          return;
        }

        this.$http.post('pageEvidence/answer', postQuestionList).then(response => {
          var count = 0;
          if (!this.hasOldQuestions) {
            for (var i = 0; i < this.questions.length; i++) {
              var group = this.questions[i];
              for (var j = 0; j < group.length; j++) {
                group[j].answerId = response[count];
                count++;
              }
            }
          }
          this.hasOldQuestions = true
          this.refreshOldQuestions();
          this.saving = false;
          this.isDirty = false;
          this.editVisible = false
          this.$message({message: 'Evidence saved successfully.', type: 'success'});

          this.$emit('saved')

        }).catch(error => {
          this.saving = false;
          this.$message.error(error.message)
        })
      },
      //提交评论
      saveComment: function (question, commentList) {
        question.isSavingComment = true;
        this.$http.post('comment', {
          pageEvidenceQuestionId: question.id,
          pageEvidenceId: this.evidenceId,
          content: question.content
        }).then(response => {
          commentList.push(response);
          this.$message({message: 'Your comment is successfully posted.', type: 'success'});
          question.content = '';
          question.isSavingComment = false;
        }).catch(error => {
          this.$message.error(error.message)
          question.isSavingComment = false;
        })
      },

      //删除评论
      cancelComment: function (comment, commentList) {
        this.$http.delete('comment/' + comment.id).then(response => {
          commentList.splice(commentList.indexOf(comment), 1)
          this.$message.success('Comment removed')
        }).catch(error => {
          this.$message.error(error.message)
        })
      },

      saveAlert: function (done) {
        if (this.isDirty) {
          this.$confirm('Confirm to leave the page without saving?', 'Warning', {
            confirmButtonText: 'Leave',
            cancelButtonText: 'Cancel',
            confirmButtonLoading: false,
            type: 'warning'
          }).then(_ => {
            this.isDirty = false;
            done();
          }).catch(_ => {
          });
        } else {
          this.isDirty = false;
          done();
        }
      },

      // 上传相关
      handleUploadError(err, file, fileList) {
        console.log('handleUploadError', file, fileList, err);
        // 注意: handleUploadError和handleRemove在出错时只有一个会被element调用到

        // 上传时出錯，检查剩下的所有文件是不是都是success状态，如果是，则视为没有正在上传
        let allLeftFileSuccess = fileList.every(file => file.status === 'success')
        if (allLeftFileSuccess) {
          this.isUploading = false
        }

        this.$message.error('File upload failed, please try again later.')

        this.imageCount--
      },
      handleBeforeImageUpload(file) {
        // 进来就要设置，因为这里检查失败的话也会走handleRemove，会imageCount--
        this.imageCount++
        console.log('handleBeforeImageUpload', this.imageCount)

        // 合法性检查
        const isImage = file.type === 'image/jpeg' || file.type === 'image/png';
//                console.log(file.type)
        const isLt4M = file.size / 1024 / 1024 < 4;

        if (!isImage) {
          this.$message.error('Only jpg/png allowed.');
          return false
        }
        if (!isLt4M) {
          this.$message.error('The size of the image should be less than 4MB.');
          return false
        }

        // return this.tryGetUploadParams(file)
      },
      handleBeforePDFUpload(file) {
        console.log('handleBeforePDFUpload entered')
        console.log(file)

        // 合法性检查
        const typeValid = file.type === 'application/pdf';
//                console.log(file.type)
        const sizeValid = file.size / 1024 / 1024 < 10;

        if (!typeValid) {
          this.$message.error('Only PDF file allowed.');
          return false
        }
        if (!sizeValid) {
          this.$message.error('The size of the PDF file should be less than 10MB.');
          return false
        }

        // return this.tryGetUploadParams(file)
      },
      buildOSSUrl: function (file) {
        return 'epq/' + this.userId + '/' + file.uid + this.getSuffix(file.name)
      },
      tryGetUploadParams(file) {
        // 走到这里就视为进入广义上的上传状态
        this.isUploading = true

        // 这个其实不用每次都设置，放这里方便统一查看
        this.uploadFormData.success_action_status = '200'
        // 文件名利用element的基于时间戳的文件uid
        this.uploadFormData.key = this.buildOSSUrl(file)

        let now = Date.now() / 1000

        // 判断是否过期，还剩少于3秒就认为过期
        if (this.expire - now < 3) {
          // 获取授权中
          this.isAuthorizing = true
          var promise = this.$http.get('/common/' + this.userId).then(response => {
            // 授权完成
            this.isAuthorizing = false

            // 地址应该不会变，但因为是请求返回的，还是每次设置一下
            this.uploadUrl = response.host

            this.uploadFormData.OSSAccessKeyId = response.accessid
            this.uploadFormData.signature = response.signature
            this.uploadFormData.policy = response.policy

            this.expire = response.expire
          })

          // 分开写，不然就会返回catch的promise了
          promise.catch(error => {
            this.isAuthorizing = false
            this.$message.error(error.message)
          })

          // 返回promise，上传不会立即开始；当Promise为resolve时才会上传，如果是rejected，则ElementUI会删掉文件并调用on-remove
          return promise
        } else {
          // 没过期就直接上传，用上次的签名
          return true
        }
      },
      handleImageRemove(file, fileList, answerList) {
        console.log('handleImageRemove', file, fileList, answerList)
        // 只要走到这就减1，不管是手动删还是element自动调用的删除。因为上传检查的时候无条件+1了，所以这里只要走到就-1
        this.imageCount--
        this.isDirty = true

        // 上传一半时人为取消了，检查剩下的所有文件是不是都是success状态，如果是，则视为没有正在上传
        // 数组长度为0时every方法会返回true，所以就不判断长度为0了
        let allLeftFileSuccess = fileList.every(file => file.status === 'success')
        if (allLeftFileSuccess) {
          this.isUploading = false
        }

        // 断网情况下开始上传file会是空，这时会失败并且会走到handleRemove
        if (file !== null) {
          // element组件删除的文件对应的OSS URL
          let fileRemoteUrl = file.remoteUrl ? file.remoteUrl : util.resizeOSSImage.switchResizeToInit(file.url)

          // 根据URL查找是否此文件已经保存到将要save到db的数组中了，如果有，则同步删除；如果没有，则什么也不做，一般意味着上传一半删除或出错了等情况element自动调了删除
          let index = -1
          for (let i = 0; i < answerList.length; i++) {
            // 一般来说，answerList里的url应该没有后缀，但存在老代码导致的数据库的既存数据已经有了后缀的情况，所以还是需要去掉逻辑
            if (fileRemoteUrl === util.resizeOSSImage.switchResizeToInit(answerList[i].url)) {
              index = i
              break
            }
          }

          if (index > -1) {
            answerList.splice(index, 1)
          }
        }
      },
      handlePDFRemove(file, fileList, answerList) {
        console.log('handlePDFRemove', file, fileList, answerList)
        this.isDirty = true

        // 上传一半时人为取消了，检查剩下的所有文件是不是都是success状态，如果是，则视为没有正在上传
        // 数组长度为0时every方法会返回true，所以就不判断长度为0了
        let allLeftFileSuccess = fileList === null || fileList.every(file => file.status === 'success')
        if (allLeftFileSuccess) {
          console.log('handlePDFRemove allLeftFileSuccess', fileList.length)
          this.isUploading = false
        }

        // 断网情况下开始上传file会是空，这时会失败并且会走到handleRemove
        if (fileList === null || fileList.length === 0) {
          answerList.splice(0, answerList.length)
        }
      },
      handleUploadImageSuccess(response, file, fileList, list){
        console.log('handleUploadImageSuccess entered', file, fileList, list)

        this.isDirty = true
        // 检查所有文件是不是都是success状态，如果是，则视为没有正在上传
        // 数组长度为0时every方法会返回true，所以就不判断长度为0了
        let allLeftFileSuccess = fileList.every(file => file.status === 'success')
        if (allLeftFileSuccess) {
          this.isUploading = false
        }

        // 设置file的remoteUrl
        file.remoteUrl = response.url
        list.push({name: file.name, url: response.key})

      },
      handleUploadPDFSuccess(response, file, fileList, list){
        console.log('handleUploadPDFSuccess entered', file, fileList, list)
        this.isDirty = true

        // 检查所有文件是不是都是success状态，如果是，则视为没有正在上传
        // 数组长度为0时every方法会返回true，所以就不判断长度为0了
        let allLeftFileSuccess = fileList.every(file => file.status === 'success')
        if (allLeftFileSuccess) {
          this.isUploading = false
        }

        fileList.splice(0, fileList.length, file)
        list.splice(0, list.length, {name: file.name, url: response.key})
      },

      handleFileChanged(file, fileList) {
        console.log(`handleFileChanged entered`, file, fileList, file.status)
        this.isDirty = true
      },
      handlePictureCardPreview(file) {
        console.log('handlePictureCardPreview entered')
        console.log(file)
        // 预览时判断，url是否为blob地址，如果是不加后缀，否则加后缀。
        this.dialogImageUrl = file.url
        this.picReview = true;
      },
      handlePDFPreview(file) {
        console.log('handlePDFPreview entered')
        console.log(file)

        // 微软系列浏览器如果是本地刚上传的，则弹出保存或打开对话框
        if (file.raw && window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(file.raw, file.name);
        } else{
          this.$refs.pdfPreview.href = file.url
          this.$refs.pdfPreview.click()
        }
      },
      getSuffix(filename) {
        let pos = filename.lastIndexOf('.')
        let suffix = ''
        if (pos != -1) {
          suffix = filename.substring(pos)
        }
        return suffix;
      },

      // 对象深拷贝方法
      deepClone(data) {
        if (typeof data !== 'object') return
        data = JSON.parse(JSON.stringify(data));
        return data
      }
    },
    mounted() {
      this.$nextTick(() => {
        this.init();
      })
    }
  }
</script>


<style lang="scss" scoped>

    @import "../../css/variable";

    .border-hearder {
        border-color: #dfe6ec !important;
        margin-top: -1px;
    }

    .pdfIcon {
        width: 50px;
        height: 50px;
    }

    //添加更多类型dropdown写成固定宽，为了视觉对齐
    .evidence-Dropdown {
        width: 172px;
    }

    .commentContent {
        white-space: pre;
        word-wrap: break-word;
        -ms-word-wrap: break-word;
        -ms-word-wrap: break-word;

        white-space: pre-wrap; /* css-3*/
        white-space: -moz-pre-wrap; /*Mozilla, since 1999*/
        white-space: -o-pre-wrap; /* Opera 7*/
        word-wrap: break-word; /*Internet Explorer 5.5+*/
    }
</style>


// WEBPACK FOOTER //
// EvidenceDialog.vue?4e1c9cdc